module.exports = __webpack_public_path__ + "img/mika-on-sinulle-tarkeaa.48c74a3f.jpg";